import { render, staticRenderFns } from "./disclosures_tab.vue?vue&type=template&id=3acfd7d4"
import script from "./disclosures_tab.vue?vue&type=script&lang=js"
export * from "./disclosures_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports